module.exports = "<input type=\"date\" class=\"material\"  ng-model=\"dateObj\" ng-change=\"onChange()\" ng-disabled=\"disabled\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/simple-date/simple-date.html
// module id = 462
// module chunks = 22